import { Bucket, BucketField, Filter } from '@commerce-search-webcomponents/sdk';
import { PLP_TYPE } from '../../types/enums';
import { CategoryAndSolutionDetails } from '../../types/propTypes';

export interface FacetsProps {
  facets: Bucket[];
  filter: Filter;
  plpType?: PLP_TYPE;
  categoryAndSolutionDetails?: CategoryAndSolutionDetails;
  priceRangeInterval?: number;
  noResultFilterName?: string;
  updateFilter: (arg: Filter) => void;
  resetFilter: () => void;
  setShowFacetsDrawer: (arg: boolean) => void;
}

export enum PriceRangeTypes {
  MIN_PRICE = 'minPrice',
  MAX_PRICE = 'maxPrice',
}

export interface FacetSectionProps {
  bucket: Bucket;
  filterData: Filter;
  categoryAndSolutionDetails?: CategoryAndSolutionDetails;
  priceRangeInterval?: number;
  minPrice: string;
  maxPrice: string;
  minPriceError: boolean;
  maxPriceError: boolean;
  isPLP?: boolean;
  priceRangeError?: boolean;
  hideItemCount?: boolean;
  onMinPriceChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onMaxPriceChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  priceInputOnClear: (e: React.MouseEvent, type: PriceRangeTypes) => void;
  updateFilterData: (arg: Filter) => void;
  checkboxOnChange: (section: keyof Filter, name: string) => void;
}

export interface FacetsDrawerProps {
  children: React.ReactNode;
  isApplyBtnDisabled: boolean;
  isResetBtnDisabled: boolean;
  onApply: () => void;
  onClose: () => void;
  onReset: () => void;
}

export type FilterBucket = Exclude<BucketField, BucketField.QUICK_FILTERS>;

export enum PRICE_SORT_KEYS {
  CUST_PRICE = 'custPrice',
  ABO_PRICE = 'aboPrice',
  EMPLOYEE_PRICE = 'empPrice',
}
